import { render, staticRenderFns } from "./DashboardOverview.vue?vue&type=template&id=16e49057&"
import script from "./DashboardOverview.vue?vue&type=script&lang=js&"
export * from "./DashboardOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports